<template>
  <div>
    <vx-card class="overflow-hidden mt-5">
      <div slot="no-body">
        <!-- box -->
        <div class="p-6" :class="['flex justify-between flex-row-reverse items-center']">
          <feather-icon
              icon="AwardIcon" class="p-3 inline-flex rounded-full"
              :class="[`text-primary`]"
              :style="{background: `rgba(var(--vs-primary),.15)`}"></feather-icon>
          <div class="truncate">
            <h3 class='mb-1 font-bold' :style="`color:#000000`" v-if="report !== null">{{ report.score|fixNumber }}</h3>
            <span>{{ familyGroup.name }}</span>
          </div>
        </div>
        <!-- box -->
        <!-- table -->
        <risk-model-result-table
          v-if="report"
          :result="report" />
        <!-- table -->
      </div>
      <template slot="footer">
        <div class="flex">
          <vs-button
              v-if="report !== null"
              @click="showChartDialogHandler"
              color="success"
              class="ml-5 mt-6 mr-2"
              icon="leaderboard">
          </vs-button>
          <vs-button
            class="mt-5"
            @click="executeVerificationProfileHandler">
            Ejecutar
          </vs-button>
        </div>
      </template>
    </vx-card>

    <vs-popup
      :title="`Historial de consultas (${familyGroup.name})`"
      :active.sync="showChartDialog">
      <vue-apex-charts
        v-if="chartData"
        type="line"
        height="350" :options="apexChatData.lineChartSimple.chartOptions" :series="apexChatData.lineChartSimple.series"></vue-apex-charts>
    </vs-popup>

  </div>
</template>

<script>
import RiskModelResult from "@views/admin/RiskModel/Dashboard/RiskModel/Components/RiskModelResult";
import {fixNumber} from "@/filters/NumberFilters";
import {RiskModel} from "@/services/ModelRisk/RiskModel";
import RiskModelResultTable from "@views/admin/RiskModel/Dashboard/RiskModel/RiskModelResultTable";
import VueApexCharts from 'vue-apexcharts'
import moment from "moment";

export default {
  name: "SupplierRiskModelByTechItem",
  components: {RiskModelResultTable, RiskModelResult, VueApexCharts},
  computed: {
    colorScoring() {
      if (this.score <= this.lowConfig[1] && this.score > this.lowConfig[0]) {
        return 'danger';
      }
      if (this.score <= this.mediumConfig[1] && this.score > this.mediumConfig[0]) {
        return 'warning'
      }
      if (this.score <= this.highConfig[1] && this.score > this.highConfig[0]) {
        return 'success';
      }
    }
  },
  filters: {
    fixNumber
  },
  props: {
    report: {
      type: [Object, null]
    },
    familyGroup: {
      type: Object,
      required: true,
    },
    supplierId: {
      type: Number,
      required: true,
    },
    highConfig: {
      type: Array,
      required: true
    },
    mediumConfig: {
      type: Array,
      required: true
    },
    lowConfig: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    showChartDialog: false,
    chartData: null,
    apexChatData: {
      lineChartSimple: {
        series: [
          {
            name: 'Score',
            data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
          }
        ],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text: 'Consultas perfil de instalador',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep']
          }
        }
      }
    }
  }),
  methods: {
    async executeVerificationProfileHandler() {
      try {
        let response = await axios.get(
            `/api/risk-model/sid/${this.supplierId}/profile-verification-sfv/form?family_group_id=${this.familyGroup.id}`
        )
        let form = response.data;


        const { data } = await axios.post('/api/risk-model/supplier-verification/run', {
          supplier_id: this.supplierId,
          family_group_id: this.familyGroup.id,
          ...form
        })

        this.report = data
      } catch (e) {
        alert(e)
      }
    },
    async showChartDialogHandler() {
      this.showChartDialog = true
      const { data } = await axios.post('/api/risk-model/supplier-verification/history', {
        supplier_id: this.supplierId,
        family_group_id: this.familyGroup.id,
      });

      this.chartData = data;

      // reset data
      this.apexChatData.lineChartSimple.chartOptions.xaxis.categories = [];
      this.apexChatData.lineChartSimple.series[0].data = [];

      for(let reportSimpleData of this.chartData) {
        this.apexChatData.lineChartSimple.chartOptions.xaxis.categories.push(moment(reportSimpleData.created_at).format("Y-M-D"))
        this.apexChatData.lineChartSimple.series[0].data.push(parseFloat(parseFloat(reportSimpleData.score).toFixed(2)))
      }
    }
  }
}
</script>

<style scoped>

</style>
